// @flow

// Effect Managers
import { call, fork } from 'redux-saga/effects'

// Controller
import controller from 'fc-ctrl-users'

// Exports
export default function *main (): Generator<*, void, *> {
  yield call(controller.start)
  yield fork(controller.watch)
}
